import * as React from 'react';
import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { PageHeading } from '../../../components/PageHeading';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';

export function AppInstallationListView({ appId, list }) {
    const breadcrumbs = [
        { label: 'Apps', link: '/extranet/apps' },
        { label: 'Dashboard', link: '/extranet/apps/' + appId + '/dashboard' },
    ];

    //TODO classes container
    return (
        <Container maxWidth="md">
            <PageHeading title="App Installations" breadcrumbs={breadcrumbs} />
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Vendor</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list.map(({ node: installation }) => (
                            <TableRow key={installation.id}>
                                <TableCell>
                                    <Link
                                        to={
                                            '/extranet/apps/' +
                                            appId +
                                            '/installations/' +
                                            installation.id
                                        }
                                        component={RouterLink}
                                    >
                                        {installation.vendor.name}
                                    </Link>
                                </TableCell>
                                <TableCell>{installation.creationDate}</TableCell>
                                <TableCell>
                                    <Button href={'/api/graphiql/' + installation.id}>
                                        Open GraphiQL
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Container>
    );
}
